import { medium } from "../size/index.js";
import container from "../container/container.js";
import defineElement from "../helpers/defineElement.js";
import stacker from "../stacker/stacker.js";

export const horizontalDirection = "horizontal";

export const verticalDirection = "vertical";

/**
 * Wraps and handles children layout. It is made so that it provide
 * a consistent spacing among children as well as around them.
 *
 * @param {object} [options]
 * @param {"horizontal"|"vertical"} [options.direction] - Specify in which direction to
 *   render its children
 * @param {ElementSize} [options.size] - Size of the space
 *   between each child
 * @param {"between"} [options.spacing] - Set the spacing policy
 * @param {boolean} [options.around] - When true, adds a gap around the whole element
 * @param {boolean} [options.top] - When true, adds a gap to the top of the whole
 *   element
 * @param {boolean} [options.right] - When true, adds a gap to the right of the whole
 *   element
 * @param {boolean} [options.bottom] - When true, adds a gap to the bottom of the whole
 *   element
 * @param {boolean} [options.left] - When true, adds a gap to the left of the whole
 *   element
 * @param {boolean} [options.noWrap] - When true, doesn't wrap the child elements in a
 *   div. Use it when you know that all the children are wrapped already
 * @param {ElementAlign} [options.align] - Specify how to align children
 * @param {boolean} [options.isBlock] - When true, the element takes full width
 * @param {boolean} [options.reversed] - When true, render the children in a
 *   reverse order
 */

export default defineElement(
	"spacer",
	(
		{
			size = medium,
			around,
			top,
			right,
			bottom,
			left,
			isBlock,
			direction,
			spacing,
			align,
			noWrap,
			fullWidth,
			reversed,
		},
		children,
	) => ({
		options: { class: { spacing, "is-block": isBlock } },
		children: container(
			{
				around,
				bottom,
				isBlock,
				left,
				right,
				size,
				top,
			},
			stacker(
				{
					align,
					direction,
					noWrap,
					isBlock,
					size,
					spacing,
					fullWidth,
					reversed,
				},
				...children,
			),
		),
	}),
);
